import { createFileRoute } from "@tanstack/react-router";
import { ProjektledelsePage, projektledelseHead } from "@/pages/ProjektledelsePage";

export const Route = createFileRoute("/en/project-management")({
  head: () => projektledelseHead("en"),
  component: () => <ProjektledelsePage locale="en" />,
});
